import { size as _size } from 'lodash-es';
import { dbSessionLookup } from 'dbServer/collections';

export const fetchSessionLookup = async () => {
	const sessionLookupData = await dbSessionLookup.getSessionLookup();
	return !_size(sessionLookupData) ? [] : sessionLookupData;
};
